import { Typography, styled } from '@mui/material';

export const StyledOurWorkWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(12),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(8),
  },
}));

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  display: 'block',
  marginBottom: theme.spacing(3),
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.85)',
  display: 'block',
  marginBottom: theme.spacing(14),
  maxWidth: '640px',
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(6),
  },
}));

export const StyledGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(4),
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),
  },
}));

export const StyledCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  overflow: 'hidden',
  background: theme.palette.background.paper,
  boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
  height: '100%',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
  },
}));

export const StyledCardImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  background: theme.palette.background.default,
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '48px',
    background: `linear-gradient(to bottom, transparent, ${theme.palette.background.paper})`,
    pointerEvents: 'none',
  },
}));

export const StyledCardImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
}));

export const StyledCardBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: theme.spacing(3),
  gap: theme.spacing(1),
}));

export const StyledCompanyName = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontWeight: 600,
  color: theme.palette.primary.main,
  fontSize: '12px',
}));

export const StyledCardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: 1.3,
  color: '#ffffff',
  marginBottom: theme.spacing(1),
}));

export const StyledCardDescription = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.75)',
  fontSize: '14px',
  lineHeight: 1.6,
  flex: 1,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const StyledReadMore = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  fontSize: '14px',
  marginTop: theme.spacing(1),
}));

export const StyledButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(6),
}));
